module.exports = __webpack_public_path__ + "media/images/category_icons/brands-e1f11ae84038f7d3c009b117f0d09514.svg";